import BaseListInput from './BaseListInput'

export default class IntegerListInput extends BaseListInput {
  parse = (v) => {
    const parsed = parseInt(v, 10)
    return Number.isNaN(parsed) ? undefined : parsed
  }

  inputProps = () => ({ type: 'number' })
}
